import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/shared/Reveal";
import { Button } from "@/components/ui/button";
import { handlePulseBriefClick } from "@/lib/pulseBriefCta";

/**
 * EarlyConversionStrip — a compact, mobile-only conversion prompt placed
 * immediately after Selected Work. It gives visitors who have just seen
 * proof-of-work an early, low-friction path to the lead form without
 * scrolling through the full journey.
 *
 * This is a lightweight visual strip only — it does NOT contain a form
 * of its own. The CTA scrolls to the existing on-page lead form via the
 * shared `handlePulseBriefClick` helper.
 */
export default function EarlyConversionStrip() {
    return (
        <section
            className="px-5 pt-2 pb-8"
            aria-label="Have a brief in mind?"
            data-testid="early-conversion-strip"
        >
            <Reveal>
                <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br from-[#0B0C10] via-[#0B0C10] to-[#170608] p-6">
                    <div className="absolute -top-20 -right-16 h-56 w-56 rounded-full bg-[#FF2A2A]/10 blur-3xl pointer-events-none" aria-hidden="true" />
                    <div className="relative">
                        <h3 className="font-display text-2xl leading-tight text-white">
                            Have a brief in <span className="text-[#FF2A2A]">mind?</span>
                        </h3>
                        <p className="mt-2 body-md text-white/75">
                            Tell us what you are planning.
                        </p>
                        <Button
                            asChild
                            className="cta-glow mt-5 bg-[#FF2A2A] hover:bg-[#ff4747] text-black font-semibold rounded-full h-12 px-6 text-sm w-full sm:w-auto"
                            data-testid="early-conversion-cta"
                        >
                            <Link
                                to="/contact"
                                onClick={handlePulseBriefClick}
                                className="inline-flex items-center justify-center gap-2"
                            >
                                Start Your Pulse Brief
                                <ArrowUpRight size={16} />
                            </Link>
                        </Button>
                    </div>
                </div>
            </Reveal>
        </section>
    );
}
